import * as React from 'react'
import styled, { css } from 'styled-components'
import Icon from '../Icon'

const StepperProgress: React.FC<{
  stepTitles: string[]
  currentStep: number
  animate?: boolean
}> = ({ stepTitles, currentStep, animate = true }) => {
  const progressPerStep = 100 / (stepTitles.length - 1)
  const progress = (currentStep - 1) * progressPerStep
  return (
    <Progress className="stepper-progress">
      <ProgressWrapper className="stepper-progress-wrapper">
        <PreProgressBar className="stepper-progress-bar">
          <ProgressBar filled={progress} animate={animate} />
        </PreProgressBar>
        {stepTitles.map((title, i) => {
          const visited = i + 1 < currentStep
          const current = i + 1 === currentStep
          return (
            <StepTitle key={i} className="step-title">
              <StepSpot className="step-title-number" visited={visited} current={current} animate={animate}>
                {visited && <Icon icon={['fa', 'check']} color="white" fontSize={14} />}
                {current && <Icon icon={['fa', 'circle']} color="blue1" fontSize={12} />}
              </StepSpot>
              <TitleText current={current} visited={visited}>
                {title}
              </TitleText>
            </StepTitle>
          )
        })}
      </ProgressWrapper>
    </Progress>
  )
}

export default StepperProgress

const Progress = styled.div`
  position: relative;
  width: 100%;
  z-index: 9;
`
const ProgressWrapper = styled.div`
  width: 90%;
  position: relative;
  display: flex;
  margin: auto;
  justify-content: space-between;
`

const PreProgressBar = styled.div`
  position: absolute;
  left: 28px;
  width: 85%;
  height: 5px;
  top: 15px;
  z-index: -1;
  background-color: ${({ theme }) => theme.colors.gray2};
`
const ProgressBar = styled.div<{ filled: number; animate: boolean }>`
  position: relative;
  left: 0;
  width: ${({ filled }) => filled + '%'};
  max-width: 100%;
  height: 5px;
  top: 0;
  z-index: -1;
  background-color: ${({ theme }) => theme.colors.blue2};
  transition: ${({ animate }) => (animate ? 'all 0.3s ease' : 'none')};
`

const StepTitle = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  font-size: 0.9rem;
  align-items: center;
  padding: 0 1rem;
  height: 30px;
`

const TitleText = styled.span<{ current: boolean; visited: boolean }>`
  color: ${({ current, visited, theme }) => (current || visited ? theme.colors.black : theme.colors.gray4)};
  margin-top: 6px;
`

const futureStep = css`
  border: 3px solid ${({ theme }) => theme.colors.gray2};
`

const currentStep = css`
  border-color: ${({ theme }) => theme.colors.white};
  box-shadow: 1px 2px 2px 0 rgba(0, 0, 0, 0.22);
`
const visitedStep = css`
  border-color: ${({ theme }) => theme.colors.white};
`

const StepSpot = styled.div<{ visited: boolean; current: boolean; animate: boolean }>`
  font-size: 1rem;
  background-color: ${({ theme, visited }) => (visited ? theme.colors.green : theme.colors.white)};
  min-width: 24px;
  min-height: 24px;
  height: 24px;
  width: 24px;
  margin: 0.3rem 0.3rem;
  line-height: 1.5;
  border-radius: 100%;
  ${({ current, visited }) => (current ? currentStep : visited ? visitedStep : futureStep)}
  transition: ${({ animate, visited }) => (animate && visited ? 'all 1s ease' : 'none')};
`
